export default __webpack_public_path__ + "static/media/lifestyle-sample-2.ea07a11c.png";